import React from 'react';
import SEO from '../../components/SEO/SEO';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import './PrivacyPage.css';

const PrivacyPage = ({ darkMode, toggleDarkMode }) => {
  return (
    <>
      <SEO 
        title="Política de Privacidad | E-ASY"
        description="Política de privacidad de E-ASY. Información sobre el tratamiento de datos personales, derechos ARCO, cookies y seguridad de la información. Cumplimiento RGPD."
        keywords="política privacidad E-ASY, RGPD, protección datos, derechos ARCO, cookies, seguridad información"
        canonical="https://e-asy.es/politica-privacidad"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`privacy-page ${darkMode ? 'dark' : 'light'}`}>
        <div className="privacy-container">
          <h1>Política de Privacidad</h1>
          <p className="privacy-subtitle">
            Protegemos tus datos personales con la máxima transparencia y seguridad
          </p>
        </div>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>¿Quiénes somos?</h2>
            <p>
              Somos <strong>E-ASY CONSULTORIA TECNOLÓGICA Y AGENCIA DIGITAL, S.L.</strong> y tratamos tus datos como Responsable del Tratamiento. 
              Eso significa que nos hacemos cargo de cómo usar y proteger tus datos personales.
            </p>
          </section>

          <section className="privacy-section">
            <h2>¿Para qué usamos tus datos?</h2>
            <p>
              Usamos los datos que nos has facilitado online o a través de cualquier otro medio para atender tus consultas y sugerencias, 
              prestarte los servicios o suministrarte los productos solicitados.
            </p>
          </section>

          <section className="privacy-section">
            <h2>¿Por qué los tenemos?</h2>
            <p>
              Estamos legitimados a tratar tus datos por diferentes motivos. Al rellenar un formulario o mandar un correo-e en el que nos planteas 
              una consulta o sugerencia tenemos un interés legítimo en atenderla.
            </p>
          </section>

          <section className="privacy-section">
            <h2>¿Con quién compartimos tus datos?</h2>
            <p>
              Solo compartiremos los datos con aquellas empresas colaboradoras para atender las solicitudes recibidas y prestar nuestros servicios 
              o facilitarte los productos, entidades bancarias y organismos obligados por ley. En ningún caso vendemos tus datos a terceros.
            </p>
          </section>

          <section className="privacy-section">
            <h2>¿Qué derechos tienes?</h2>
            <p>
              Tienes derecho a acceder, rectificar o suprimir tus datos personales. También tienes derecho a oponerte a que usemos datos que nos hayas 
              autorizado a usar previamente, a portarlos y a no ser objeto de decisiones individualizadas automatizadas.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Principios de Protección de Datos</h2>
            <p>En el tratamiento de tus datos personales, aplicamos los siguientes principios para garantizar la mayor protección para ti:</p>
            
            <div className="privacy-principles">
              <div className="principle-item">
                <h3>Principio de licitud, lealtad y transparencia</h3>
                <p>
                  Siempre vamos a requerir tu consentimiento para el tratamiento de tus datos personales para uno o varios fines específicos 
                  que te informaremos previamente con absoluta transparencia.
                </p>
              </div>

              <div className="principle-item">
                <h3>Principio de minimización de datos</h3>
                <p>
                  Solo vamos a solicitar datos estrictamente necesarios en relación con los fines para los que los requerimos. Los mínimos posibles.
                </p>
              </div>

              <div className="principle-item">
                <h3>Principio de limitación del plazo de conservación</h3>
                <p>
                  Los datos serán mantenidos durante no más tiempo del necesario para los fines del tratamiento, en función a la finalidad, 
                  te informaremos del plazo de conservación correspondiente.
                </p>
              </div>

              <div className="principle-item">
                <h3>Principio de integridad y confidencialidad</h3>
                <p>
                  Tus datos serán tratados de tal manera que se garantice una seguridad adecuada de los datos personales y se garantice confidencialidad. 
                  Tomamos todas las precauciones necesarias para evitar el acceso no autorizado.
                </p>
              </div>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Información del Responsable del Tratamiento</h2>
            <div className="company-info">
              <div className="info-item">
                <strong>Identidad:</strong> E-ASY CONSULTORIA TECNOLÓGICA Y AGENCIA DIGITAL, S.L. – B72696636
              </div>
              <div className="info-item">
                <strong>Dirección:</strong> Carretera Santa María 22, Edificio Intech
              </div>
              <div className="info-item">
                <strong>Teléfono:</strong> 822685012
              </div>
              <div className="info-item">
                <strong>Web:</strong> e-asy.es
              </div>
              <div className="info-item">
                <strong>Correo-e:</strong> administracion@e-asy.es
              </div>
            </div>
          </section>

          <section className="privacy-section">
            <h2>Finalidades del Tratamiento</h2>
            <p>Tratamos tus datos para las siguientes finalidades:</p>
            <ul>
              <li>Atender tus consultas y solicitudes</li>
              <li>Prestar los servicios contratados</li>
              <li>Gestionar la relación comercial</li>
              <li>Enviar comunicaciones comerciales (con tu consentimiento)</li>
              <li>Cumplir con las obligaciones legales</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Legitimación del Tratamiento</h2>
            <p>El tratamiento de tus datos está basado en:</p>
            <ul>
              <li><strong>Consentimiento:</strong> Para el envío de comunicaciones comerciales</li>
              <li><strong>Interés legítimo:</strong> Para atender consultas y gestionar la relación comercial</li>
              <li><strong>Cumplimiento legal:</strong> Para cumplir con las obligaciones fiscales y contables</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Conservación de Datos</h2>
            <p>
              Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad para la que fueron recabados y 
              para determinar las posibles responsabilidades que se pudieran derivar de dicha finalidad y del tratamiento de los datos.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Destinatarios</h2>
            <p>
              No se cederán datos a terceros salvo obligación legal o en el supuesto que sea necesario para atender tu solicitud. 
              Entre los destinatarios se encuentran:
            </p>
            <ul>
              <li>Administraciones y Organismos públicos cuando así lo exija la normativa</li>
              <li>Empresas encargadas del tratamiento de datos (proveedores tecnológicos, servicios de atención al cliente, etc.)</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Ejercicio de Derechos</h2>
            <p>Puedes ejercer tus derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición enviando un escrito a:</p>
                         <div className="contact-info">
               <p><strong>Dirección:</strong> E-ASY CONSULTORÍA TECNOLÓGICA Y AGENCIA DIGITAL, S.L.</p>
               <p>Carretera Santa María 22, Edificio Intech</p>
               <p><strong>Email:</strong> administracion@e-asy.es</p>
             </div>
            <p>
              <strong>Plazo de respuesta:</strong> Un mes desde la recepción de la solicitud, prorrogable por otros dos meses si fuera necesario.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Seguridad de Datos</h2>
            <p>
              E-ASY CONSULTORIA TECNOLÓGICA Y AGENCIA DIGITAL, S.L. garantiza la adopción de las medidas oportunas para asegurar 
              el tratamiento confidencial de tus datos. Nuestra web posee un certificado SSL que permite establecer conexiones cifradas.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Autoridad de Control</h2>
            <p>
              Tienes derecho a reclamar ante la Agencia Española de Protección de Datos (www.aepd.es) cuando consideres que hemos 
              vulnerado los derechos que la normativa de protección de datos te reconoce.
            </p>
          </section>

          <section className="privacy-section">
            <div className="privacy-footer">
              <p><strong>Fecha:</strong> 21 diciembre 2022</p>
              <p><strong>Versión:</strong> V.1.0</p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPage; 